import TimerPage from '../views/timer/decorators/TimerPage';
import TimerSession from '../views/timer/decorators/TimerSession';
/**
 * this will be refactored with new timer service.
 */
class PageTimerService {
  constructor(type = 'page', $domEl = '', countdown = 0) {
    // if domEl is undefined, it will be a background timer like the legacy timer.
    // countdown; if 0 it will countup.
    if (type === 'page') {
      this.timer = new TimerPage(countdown, $domEl);
    }
    if (type === 'session') {
      this.timer = new TimerSession(countdown, $domEl);
    }  
  }

  start() {
    if(this.timer) this.timer.startTimer();
  }

  clear() {
    this.timer.resetTimer();
  }

  save(data) {
    $.post(`/sdk/enrollments/${EF.enrollment.id}/events`, {
      event: {
        name: 'Page Completion Time',
        data: Object.assign({time: this.timer.currentTime}, data)
      }
    }).always(() => {
      this.timer.resetTimer();
    });
  }
}

module.exports = PageTimerService;
